import { Type } from 'class-transformer';
import {
  IsEnum,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';

export class EntityProposalPayloadDto {
  @IsString()
  @IsOptional()
  type?: string;

  @IsNumber()
  @IsOptional()
  minTemperature?: number;

  @IsNumber()
  @IsOptional()
  maxTemperature?: number;

  @IsString()
  @IsOptional()
  description?: string;

  /** DOCUMENT only: key into the backend's expiring-document catalog. */
  @IsString()
  @IsOptional()
  catalogKey?: string;

  /** DOCUMENT only, compute-on-read: id of the linked survey template that
   * generates this document, present only when live and visible to the caller. */
  @IsString()
  @IsOptional()
  surveyTemplateId?: string;
}

export class EntityProposalResponseDto {
  @IsUUID('4')
  id!: string;

  @IsEnum(['EQUIPMENT', 'CLEANING_AREA', 'PEST_CONTROL_POINT', 'FRYER', 'DOCUMENT'])
  entityType!: 'EQUIPMENT' | 'CLEANING_AREA' | 'PEST_CONTROL_POINT' | 'FRYER' | 'DOCUMENT';

  @IsString()
  name!: string;

  @ValidateNested()
  @Type(() => EntityProposalPayloadDto)
  @IsOptional()
  payload!: EntityProposalPayloadDto | null;

  /** DRAFT: found in the new manual; IMPORTED_MANUAL: found only in the tenant's old imported PDF. */
  @IsEnum(['DRAFT', 'IMPORTED_MANUAL'])
  sourceKind!: 'DRAFT' | 'IMPORTED_MANUAL';

  /** Pages of the old imported PDF; empty unless sourceKind is IMPORTED_MANUAL. */
  @IsInt({ each: true })
  sourcePages!: number[];

  /** Null for IMPORTED_MANUAL proposals that relate to no section of the new draft. */
  @IsString()
  @IsOptional()
  sourceSectionKey!: string | null;

  @IsString()
  @IsOptional()
  quote!: string | null;

  @IsEnum(['PROPOSED', 'ACCEPTED', 'REJECTED'])
  status!: 'PROPOSED' | 'ACCEPTED' | 'REJECTED';
}
